import { render } from "./UpdateProfileForm.vue?vue&type=template&id=2f8921a7&scoped=true"
import script from "./UpdateProfileForm.vue?vue&type=script&lang=js"
export * from "./UpdateProfileForm.vue?vue&type=script&lang=js"

import "./UpdateProfileForm.vue?vue&type=style&index=0&id=2f8921a7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2f8921a7"

export default script